import http from "./http";

export type SystemHealthErrorRate = {
	pct4xx: number;
	pct5xx: number;
	pctTotal: number;
	count4xx: number;
	count5xx: number;
};

export type SystemHealthLatency = {
	p50: number;
	p95: number;
	p99: number;
	avg: number;
	max: number;
};

export type SystemHealthDb = {
	bytes: number | null;
	pretty: string | null;
	error?: string;
};

export type SystemHealth = {
	windowMs: number;
	requests: number;
	reqPerSec: number;
	errorRate: SystemHealthErrorRate;
	latencyMs: SystemHealthLatency;
	uptimeSec: number;
	sampleCapacity: number;
	samplesHeld: number;
	at: string;
	// Có thể vắng nếu backend cũ chưa hỗ trợ.
	db?: SystemHealthDb;
};

export default async function getSystemHealth(): Promise<SystemHealth> {
	const { data } = await http.get("/admin/system-health");
	return data;
}
